document.addEventListener('turbolinks:load', function() {
  const styleId = 'add-to-playlist-dropdown-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .add-to-playlist {
        position: relative;
      }
      .add-to-playlist .dropdown-menu {
        display: none;
        position: fixed;
        z-index: 9999;
        min-width: 14rem;
        max-height: 16rem;
        overflow-y: auto;
        overscroll-behavior: contain;
        padding: 0.5rem 0;
        margin: 0;
        background-color: #191919;
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 0.25rem;
      }
      .add-to-playlist .dropdown-menu.show {
        display: block;
      }
      .add-to-playlist .dropdown-menu .dropdown-item {
        color: #ffffff;
        padding: 0.5rem 1rem;
      }
      .add-to-playlist .dropdown-menu .dropdown-item:hover,
      .add-to-playlist .dropdown-menu .dropdown-item:focus {
        background-color: #252525;
        color: #ffffff;
      }
      .add-to-playlist .dropdown-menu .dropdown-divider {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        margin: 0.5rem 0;
      }
      .add-to-playlist .dropdown-menu .btn-link {
        color: #ffffff;
        text-decoration: none;
        width: 100%;
        text-align: left;
        padding: 0;
      }
      .add-to-playlist .dropdown-menu .btn-link:hover,
      .add-to-playlist .dropdown-menu .btn-link:focus {
        color: #ffffff;
        text-decoration: none;
      }
    `;
    document.head.appendChild(style);
  }

  function positionDropdown($toggle, $dropdownMenu) {
    const toggleRect = $toggle[0].getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const desiredLeft = Math.max(8, toggleRect.left);
    const menuWidth = Math.max(toggleRect.width, 224);
    const maxLeft = Math.max(8, viewportWidth - menuWidth - 8);
    const left = Math.min(desiredLeft, maxLeft);

    $dropdownMenu.css({
      top: `${toggleRect.bottom + 4}px`,
      left: `${left}px`,
      minWidth: `${menuWidth}px`
    });
  }

  function closeAllDropdowns() {
    $('.add-to-playlist .dropdown-menu').removeClass('show');
  }

  // Initialize all playlist dropdowns manually
  $(document)
    .off('click.playlistDropdown', '.add-to-playlist .dropdown-toggle')
    .on('click.playlistDropdown', '.add-to-playlist .dropdown-toggle', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $toggle = $(this);
    const $dropdownMenu = $(this).next('.dropdown-menu');

    if ($dropdownMenu.hasClass('show')) {
      $dropdownMenu.removeClass('show');
      return;
    }

    closeAllDropdowns();
    positionDropdown($toggle, $dropdownMenu);
    $dropdownMenu.toggleClass('show');
  });

  $(window)
    .off('scroll.playlistDropdown resize.playlistDropdown')
    .on('scroll.playlistDropdown resize.playlistDropdown', function() {
      const $openDropdown = $('.add-to-playlist .dropdown-menu.show');
      if ($openDropdown.length) {
        const $toggle = $openDropdown.prev('.dropdown-toggle');
        if ($toggle.length) {
          positionDropdown($toggle, $openDropdown);
        }
      }
    });

  // Close dropdown when clicking outside
  $(document)
    .off('click.playlistDropdownOutside')
    .on('click.playlistDropdownOutside', function(e) {
    if (!$(e.target).closest('.add-to-playlist, .add-to-playlist .dropdown-menu').length) {
      closeAllDropdowns();
    }
  });

  $(document)
    .off('click.playlistDropdownMenu', '.add-to-playlist .dropdown-menu')
    .on('click.playlistDropdownMenu', '.add-to-playlist .dropdown-menu', function(e) {
      e.stopPropagation();
    });
});
